
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 34.328a1 1 0 01-.71-.29l-4.7-4.71H15a1 1 0 01-1-1v-8a1 1 0 011-1h3.59l4.7-4.71a1 1 0 011.09-.21 1 1 0 01.62.92v18a1 1 0 01-.62.92.84.84 0 01-.38.08zm8-10a8.002 8.002 0 01-2.55 5.84l1.34 1.48a10.001 10.001 0 000-14.64l-1.34 1.48a8 8 0 012.55 5.84zm-4.319 1.558A4 4 0 0028 24.328a4 4 0 00-1.22-2.87l1.34-1.48a6.002 6.002 0 010 8.7l-1.34-1.48a4 4 0 00.901-1.312z","fill":"#fff"}})])
          )
        }
      }
    